<template>
    <line-content
        :title="title"
        :styleClass="styleClass"
        :explanation="explanation"
        :explanationLinkTo="explanationLinkTo"
        :alert="alert"
        :inputRequire="inputRequire"
    >
        <UploadPic
            ref="uploadPic"
            @onChangePics="onChangePics"
            :inputName="inputName"
            :postMaxSize="postMaxSize"
            :uploadMaxSize="uploadMaxSize"
            :maxFileUploads="maxFileUploads"
            :picDatas="value"
            :relatedPicName="relatedPicName"
            :hideUploadButton="hideUploadButton"
            :hideListButtonKeys="hideListButtonKeys"
        ></UploadPic>
    </line-content>
</template>

<script>
import LineContent from 'FF/Vue/ControlCenter/CustomComponent/EditControlCenter/LineContent/Base/LineContent';
import UploadPic from "FF/Vue/Common/Upload/UploadPic/UploadPic";

export default {
    props: [
        'title',
        'styleClass',
        'value',
        'inputName',
        'postMaxSize',
        'uploadMaxSize',
        'maxFileUploads',
        'explanation',
        'explanationLinkTo',
        'relatedPicName',
        'alert',
        'hideUploadButton',
        'hideListButtonKeys',
        'inputRequire',
    ],
    components: {
        LineContent,
        UploadPic
    },
    data: () => {
        return {
          picIds: []
        }
    },
    methods: {
      onChangePics(picIds) {
        this.picIds = picIds;
        this.$emit('onChangePics', picIds); // 發送事件
      },
      clearPics() {
        this.picIds = [];
        this.$refs.uploadPic.clearPics();
      },
    }
};
</script>
